import Nav from "../components/site/Nav";
import Hero from "../components/site/Hero";
import Product from "../components/site/Product";
import Applications from "../components/site/Applications";
import InvisibleByDesign from "../components/site/InvisibleByDesign";
import ModernConstruction from "../components/site/ModernConstruction";
import EnergyAndHotWater from "../components/site/EnergyAndHotWater";
import Control from "../components/site/Control";
import Design from "../components/site/Design";
import Lifecycle from "../components/site/Lifecycle";
import WhyEcoHeatwave from "../components/site/WhyEcoHeatwave";
import CustomerLogos from "../components/site/CustomerLogos";
import VideoGallery from "../components/site/VideoGallery";
import FinalCTA from "../components/site/FinalCTA";
import Footer from "../components/site/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-ecoh-bg text-ecoh-ink">
      <Nav />
      <main>
        <Hero />
        <Product />
        <InvisibleByDesign />
        <ModernConstruction />
        <Lifecycle />
        <Control />
        <Design />
        <EnergyAndHotWater />
        <Applications />
        <WhyEcoHeatwave />
        <CustomerLogos />
        <VideoGallery />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
